module.exports = __webpack_public_path__ + "img/coup33.44016d60.png";